import React from "react";
import { Link } from "react-router-dom";
import { BtnWhatsapp } from "../btnWhatsapp";
import { LeadForm } from "../leadForm";
import LogoOficialColor from "../../assets/imgs/JC Congresos y convenciones.png";
import LogoOficial from "../../assets/imgs/JC-Congresos-y-convenciones-blanco.png";
import LogoAxenza from "../../assets/imgs/Logo-axenza.png";
import "./footer.scss";

import LogoIso from "../../assets/imgs/ISO.png";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  const anioActual = () => {
    var fecha = new Date().getFullYear();
    return fecha;
  };
  return (
    <footer className="wrapper_footer">
      <div className="drawer_footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-5 info_foot_msnj">
              <div className="info__msnj">
                <h1 className="mt-1 fw_600">
                  {t("¿Tienes una idea para tu evento?")}
                </h1>
                <p style={{ fontSize: "1.25rem" }}>
                  {t("No te preocupes, nosotros nos encargamos de todo")}{" "}
                </p>
                <div className="sec_links_socials">
                  <div className="socials">
                    <a
                      target="_blank"
                      title="Facebook"
                      rel="nofollow noopener noreferrer"
                      href="https://www.facebook.com/jcinnovationoficial"
                    >
                      <i className="fa-brands fa-facebook-square"></i>
                    </a>
                    <a
                      target="_blank"
                      title="Instagram"
                      rel="nofollow noopener noreferrer"
                      href="https://www.instagram.com/jcinnovationoficial/"
                    >
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                    <a
                      target="_blank"
                      title="Twitter"
                      rel="nofollow noopener noreferrer"
                      href="https://twitter.com/jc_innovation"
                    >
                      <i className="fa-brands fa-x-twitter"></i>
                    </a>
                    <a
                      target="_blank"
                      title="Linkedin"
                      rel="nofollow noopener noreferrer"
                      href="https://www.linkedin.com/company/jc-innovation/"
                    >
                      <i className="fa-brands fa-linkedin"></i>
                    </a>
                    <a
                      target="_blank"
                      title="Linkedin"
                      rel="nofollow noopener noreferrer"
                      href="https://maps.app.goo.gl/TCTv8vQDpzswYDmo9"
                    >
                      <i className="fa fa-map-marker" aria-hidden="true"></i>
                    </a>
                    {/* <a
                      target="_blank"
                      title="Youtube"
                      rel="nofollow noopener noreferrer"
                      href="https://www.youtube.com/channel/UCx0MHsRF0UzEW14iUOS4vOQ"
                    >
                      <i className="fa-brands fa-youtube"></i>
                    </a> */}
                  </div>
                  <img className="img_iso" src={LogoIso} alt="ISO Certified" />
                </div>
              </div>
              {/* <div>
                <BtnWhatsapp />
              </div> */}
            </div>
            <div className="col-md-7 p-0">
              <LeadForm />
            </div>
          </div>
        </div>
      </div>
      <div className="drawer_foot_pie_a">
        <div className="container-lg">
          <div className="foot_pie_a">
            <div className="text-center">
              <span className="ico_pie">
                <i className="fa-solid fa-location-dot"></i>
              </span>{" "}
              <a
                target="_blank"
                className="label_pie"
                rel="nofollow noopener noreferrer"
                href="https://maps.app.goo.gl/TCTv8vQDpzswYDmo9"
              >
                Nebraska 62, Nápoles, Benito Juárez, 03810 Ciudad de México,
                CDMX
              </a>
              <div>
                <span className="ico_pie">
                <i class="fa-solid fa-map-location"></i>
              </span>{" "}
              <a
                target="_blank"
                className="label_pie"
                rel="nofollow noopener noreferrer"
                href="https://maps.app.goo.gl/gqgDunqgyMx435ST7"
              >
                Av. Ignacio Comonfort No 1312 planta baja, suite B5, Col. La Providencia, Metepec, Estado de México , CP 52177 <br /> Modalidad COWORKING
              </a>
              </div>
    
            </div>
            <div className="text-center">
              <span className="ico_pie">
                <i className="fa-solid fa-phone"></i>
              </span>{" "}
              <a
                className="label_pie"
                href="tel:+5565865748"
                rel="nofollow noopener noreferrer"
              >
                (556) 586 5748
              </a>
<br />
              <span className="ico_pie">
                <i className="fa-regular fa-envelope"></i>
              </span>{" "}
              <a
                className="label_pie"
                href="mailto:contacto@jc-innovation.com"
                rel="nofollow noopener noreferrer"
              >
                contacto@jc-innovation.com
              </a>

            </div>
            <div className="marcas_footer text-center">
              <p className="text-center">Nuestras marcas</p>
            <img
                className="logo_brand_footer"
                src={LogoOficial}
                alt="JC Congresos y convenciones"
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <a
                target="_blank"
                className="label_pie"
                href="https://axenza.mx/"
                rel="nofollow noopener noreferrer"
              >
               <img
                className="logo_brand_footer_axenza"
                src={LogoAxenza}
                alt="Axenza"
              />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="drawer_foot_pie">
        <div className="container-lg">
          <div className="text-center">
            <small>
              Copyright ©{anioActual()}{" "}
              {t("JC-Innovation. Todos los Derechos Reservados.")}
            </small>
          </div>
        </div>
      </div>
    </footer>
  );
};
